import axios from '@axios'

export default {
  namespaced: true,
  actions: {
    fetchContracts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('contracts', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchContactors(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`userGetLinked`, { params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchContract(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`contracts/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createContract(ctx, contractData) {
      return new Promise((resolve, reject) => {
        axios.post('contracts', contractData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editContract(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.put(`contracts/${form.id}`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deleteContract(ctx, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`contracts/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
